import { render, staticRenderFns } from "./LessonQuestionnaireEdit.vue?vue&type=template&id=00a4f7fa&scoped=true&"
import script from "./LessonQuestionnaireEdit.vue?vue&type=script&lang=ts&"
export * from "./LessonQuestionnaireEdit.vue?vue&type=script&lang=ts&"
import style0 from "./LessonQuestionnaireEdit.vue?vue&type=style&index=0&id=00a4f7fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4f7fa",
  null
  
)

export default component.exports